export const hasPromotionPricingIssue = (reasons = []) => reasons.some((reason) =>
  /^(promotion_|coupon_|repeatable_promotion_|multiple_promotions_)/.test(reason || ""));

export const promotionPricingMessage = (arabic = false) => arabic
  ? "تعذر تأكيد العرض لهذا الطلب. راجع شروط العرض وخيارات الطلب قبل المتابعة. لم يتم تأكيد المجموع بعد."
  : "This offer could not be confirmed for your order. Review its conditions and your order options before continuing. Your total is not confirmed yet.";
